import React, { useState } from 'react'
import { useProfileMutation } from './QueryClient'
import {
  BriefcaseIcon,
  CalendarIcon,
  EnvelopeIcon,
  PhoneIcon,
  UserIcon,
  ClockIcon,
} from '@heroicons/react/24/outline'
import {
  Panel,
  IconTextField,
  TextField,
  TextareaField,
  FormDataProvider,
  EditSaveCancelButtons,
} from './blocks'
import { ProfilePhoto } from './ProfilePhoto'

const BasicInformation = ({ user, hrPortalProfile, photoUrl }) => {
  const { first_name: firstName, last_name: lastName } = user || {}
  const initials = '' + firstName?.charAt(0) + lastName?.charAt(0)

  const [formData, setFormData] = useState(hrPortalProfile)

  const profileMutation = useProfileMutation()

  const dataChanged =
    JSON.stringify(formData) !== JSON.stringify(hrPortalProfile || {})

  const saveClick = () => {
    dataChanged ? profileMutation.mutate(formData) : cancelClick()
  }

  const cancelClick = () => {
    setFormData(hrPortalProfile)
  }

  return (
    <Panel>
      <FormDataProvider formData={formData} setFormData={setFormData}>
        <div className="flex w-full flex-row justify-between">
          <div className="text-xl font-medium tracking-wide text-intoo-text">
            Basic Information
          </div>
          <EditSaveCancelButtons
            sectionName="Profile"
            saveClick={saveClick}
            cancelClick={cancelClick}
          />
        </div>
        <div className="flex flex-col gap-y-3">
          <div className="font-medium text-intoo-text">Profile Photo</div>
          <ProfilePhoto photoUrl={photoUrl} placeholder={initials} />
        </div>
        <TextareaField
          label="Bio"
          name="bio"
          placeholder="Write a short bio about yourself..."
        />
        <div className="grid gap-6 md:grid-cols-2">
          <IconTextField
            icon={EnvelopeIcon}
            label="Email"
            name="email"
            placeholder="john.doe@company.com"
          />
          <IconTextField
            icon={PhoneIcon}
            label="Phone"
            name="phone"
            placeholder="+1 (555) 000-0000"
          />
          <TextField
            label="LinkedIn Profile"
            name="linkedin"
            placeholder="linkedin.com/in/johndoe"
          />
          <IconTextField
            icon={BriefcaseIcon}
            label="Years of Experience"
            name="years_experience"
          />
          <IconTextField
            icon={CalendarIcon}
            label="Years with Company"
            name="years_with_company"
          />
          <IconTextField icon={UserIcon} label="Job Title" name="title" />
          <IconTextField icon={ClockIcon} label="Hours" name="hours" />
          <IconTextField
            icon={CalendarIcon}
            label="Calendly Link"
            name="calendly_link"
          />
        </div>
      </FormDataProvider>
    </Panel>
  )
}
export default BasicInformation
